import services from './../../services/service'; // Service Class
import MainHeader from './../Main-Header/index.vue'; // Dashboard Header
import Sidebar from './../Sidebar/index.vue'; // Dashboard Sidebar
import MainFooter from './../Main-Footer/index.vue'; // Dashboard Footer
let service = new services();

export default {
    name: 'Users',
    data () {
        return {
            admin:{},
            users: {},
            referrals:{},
            total_referrals:0,
            disable_btn:false,
        }
    },
    components: {
        'component-header': MainHeader,
        'component-sidebar': Sidebar,
        'component-footer': MainFooter
    },
    methods: {
        //settings
        
        isActive(index){
            if(index == 1){
                return "active";
            }
        },
        preset() {
            var credentials = {
                session_key: localStorage.getItem("cityneeds_a_token")
            } 
            if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            this.admin.admin_id = element.admin_id;
                        }, this);
                        }else {
                            this.$router.push('/');
                      }
                }).catch((err) => {
                    if(err) {
                     this.$router.push('/');
                    }
                })
            }else {
                this.$router.push('/');
            }
            
        },

        //quotes and contracts
       

        //referral
        setreferralTransaction(txn){
            this.referral_transaction = txn;
        },
        
        getReferralsTransactions() {
            service.getReferralsTransactions(this).then(data => {
                 this.referrals = data.body.data;
                 this.total_referrals = data.body.total_referrals;
            }).catch((err) => {
                 if(err) {
                     toastr.error('Sorry, could not process information', 'Warning!');
                 }
             })
        }, 

        formatCurrency(currency){
            currency =  Intl.NumberFormat('en-US', { style: 'currency', currency: 'NGN'}).format(currency);
            return currency.replace("NGN", ""); //strip off NGN
        },

    
    //referral

    
        
    },
    created: function(){
        this.preset();
        this.getReferralsTransactions();
    }
}


// WEBPACK FOOTER //
// ./src/components/Referrals/script.js